import { OnInit, Optional, Inject, Component, ViewChild, Input } from '@angular/core';
import { CoreConstants, IAppDataStore, IAuthorizationService , PershingTranslationService } from '@pershing/pershing-core';
import { NguCarousel, NguCarouselConfig } from '@ngu/carousel';
import { Subscription, interval } from 'rxjs'
import { OverviewHoldingsService } from '../../services/overview-holdings.services';
import { SymbolService } from "../../services/symbol.service";
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'overview-market-news',
  templateUrl: './overview-market-news.component.html'
})
export class OverViewMarketNewsComponent implements OnInit {

  public dataBlock: any[] = new Array();
  private appSettings: any;
  holdingsResponseValue: any;
  assetMoverDetails: any;
  stringRegex: any;
  pipedSymbols: any;
  carouselItems: any = [];
  arrayOfSymbal: any = [];
  allAccountList: any = [];
  allStocks: any = [];
  accountList: any = [];
  items: any = [];
  finalstrongStocks: any = [];
  accountNumber: string;
  coreConstant;
  ibd: string;
  modNewsUrl: string;
  dateString: any;
  holdingSymbolDetails: Subscription;
  modNewsDetails: Subscription;
  isLoading: boolean = true;
  isNoData: boolean = false;
  hasEntitled:boolean = true;
  modcount = 0;
  errorflag: boolean = false;
  nodataflag: boolean = false;
  uniqueStocksSybmol: any = [];
  @Input() columnPosition: string = 'left';
  
  @ViewChild("myCarousel", { static: false }) myCarousel: NguCarousel;

  carouselConfig: NguCarouselConfig = {
    grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
    load: 2,
    slide: 1,
    interval: { timing: 3000, initialDelay: 1000 },
    loop: true,
    velocity: 0.2,
    point: {
      visible: true,
      hideOnSingleSlide: true,
    },
  };

  iconVisible: boolean = false;

  carouselItem: any = [];
  constructor(
    private translationService: PershingTranslationService,
    private appDataStore: IAppDataStore,
    private overviewHoldingsService: OverviewHoldingsService,
    private symbolService: SymbolService,
    private permissionCheck:IAuthorizationService,
    @Optional() @Inject('AppSettings') appSettings: any
  ) {
    translationService.addTranslationFolder(
      "@pershing/nxi-ng-mod",
      "node_modules/@pershing/nxi-ng-mod/lib"
    );
    this.ibd = appSettings.ibdConfigMap.IBD;
    this.modNewsUrl = appSettings.ibdConfigMap.modApiUrl;
  }

  ngOnInit() {
    let sub = interval(1000).subscribe((val) => {
      if (this.appDataStore.get("ACCOUNTS_LIST") != null) {
        this.allAccountList = this.appDataStore.get("ACCOUNTS_LIST");
        // console.log(this.allAccountList);

        if (this.allAccountList.length > 0) {
          this.accountList = this.allAccountList.filter(this.extractAccounts);
          // console.log(this.accountList);
          if (this.accountList.length > 1 && this.accountList.length != 1) {
            this.accountNumber =
              this.ibd + "_" + this.allAccountList[0].groupId + "_C";
            this.coreConstant = CoreConstants.GROUP;
          } else if (this.accountList.length == 1) {
            this.accountNumber = this.accountList[0].acctNo;
            this.coreConstant = CoreConstants.ACCOUNT;
          }
        }
        sub.unsubscribe();
        this.getprocessSymbolData();
      }
    });

      this.validate();
  
  }
  extractAccounts(item) {
    return item.acctNo != null && item.acctNo != "ALL";
  }

  getprocessSymbolData() {
    if (this.accountNumber !== '' && this.accountNumber !== undefined) {
      this.holdingSymbolDetails = this.overviewHoldingsService.getHoldingsResponse(this.coreConstant, this.accountNumber, 'D').subscribe(resp => {
        if (!!resp  && resp.errorDescription === "SUCCESS") {
          this.modcount = 0;
          this.holdingsResponseValue = resp;
          console.log(resp.status);
          this.isLoading = false;
          this.errorflag = false;
          if (this.holdingsResponseValue.response) {
            this.handleResponse();
            let sortedResponse=  this.uniqueStocksSybmol.slice().sort((a, b) => b.todayMarketValue.baseCcy - a.todayMarketValue.baseCcy);
            let slicedArray = sortedResponse.slice(0,21);
            for (const key in slicedArray) {
              this.allStocks.push(slicedArray[key]);
              this.pipedSymbols += "|" + slicedArray[key].symbol;
            }
  
          this.getNewsData(this.pipedSymbols, this.modNewsUrl);
          } else if(this.holdingsResponseValue.response === null) {
            this.isNoData = true;
          }
        } else if(!!resp && resp.errorDescription !== "SUCCESS") {
          this.isLoading = false;
          this.errorflag = true;
        }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          this.errorflag = true;
        } else {
          this.errorflag = true;
        }
        this.isLoading = false;
      });
    }
  }
  
  getPartialRes(item2:any){
    this.stringRegex=/^[A-Za-z\s]+$/; 
    if ((item2.security.assetTypeCode == 'S' || item2.security.assetTypeCode=='EQUITY') && this.stringRegex.test(item2.symbol)) {
        if(!!item2.symbol && !!item2.todayMarketValue.baseCcy) {
          this.pushuniqueSymbol(item2);
          this.finalstrongStocks.push(item2);
        }  
    }
  }
  pushuniqueSymbol(obj) {
    for (var i = 0; i < this.finalstrongStocks.length; i++) {
      if ( this.finalstrongStocks[i].symbol === obj.symbol) { 
        return;
      }
    }
    this.uniqueStocksSybmol.push(obj);
  }

  getNewsData(params: any, modurl: any) {
    if (params !== '' && params !== undefined) {
      this.modNewsDetails = this.overviewHoldingsService.getModNewsResponse(params, this.modNewsUrl).subscribe(resp => {
        if(resp.length === 0) {
          this.isNoData = true;
         
        } else {
          this.isNoData = false;
         
        }
        if (resp.length > 3) {
          this.iconVisible = true;
          this.carouselItem = [{
            data: resp.slice(0, 3)
          },
          {
            data: resp.slice(3)
          }]
        } else {
          this.iconVisible = false;
          this.carouselItem = [{
            data: resp
          }];
        }
        this.assetMoverDetails = resp;
      });
    }


  }
  mouseEnter() {
    if (this.assetMoverDetails.length > 3) {
      this.iconVisible = true;
    }
  }

  validate(){
    let role="NXI_FINANCIAL_PLANNING_ACCESS";
    let role2="DIGITAL_AUTHORIZATION";

    let count = 0;
    let firstRole = this.permissionCheck.isEntitled(role);
    let secondRole = this.permissionCheck.isEntitled(role2);

    if(firstRole){
      count++;
    }
    if(secondRole){
      count++;
    }
    
    if(count > 0 && this.columnPosition == "left"){
      this.hasEntitled = true
    }
    else if (count == 0 && this.columnPosition == "right"){
     this.hasEntitled = true
    }else {
      this.hasEntitled = false;
    }

  }
  getDiffHours(dt2) {
    var Hours: number;
    let Todayate = new Date();
    let responseDate = new Date(dt2);
    Todayate.toDateString();
    responseDate.toDateString();
    let diff = (responseDate.getTime() - Todayate.getTime()) / 1000;
    diff /= (60 * 60);
    Hours = Math.abs(Math.round(diff));
    if (Hours < 24) {
      this.dateString = Hours + " hrs ago";
    } else {
      this.dateString = new Date(dt2).toDateString().slice(4);
    }
    return this.dateString;

  }
  navigateSymbol(symbol) {
    this.symbolService.navigateSymbol(symbol);
  }


  mouseLeave() {
    this.iconVisible = false;

  }
  openBalancs() {
    document.dispatchEvent(
      new CustomEvent("portal.gotoview", {
        detail: {
          gotoPage: "/nxi/research/markets/news",
        },
      })
    );
  }
  handleResponse() {
    if(this.holdingsResponseValue['response'].children) {
      let res1 = this.holdingsResponseValue['response'].children;
      this.assetMoverDetails = res1;
      res1.forEach(item =>
        item.positions.forEach(item2 => {
         this.getPartialRes(item2);
        })
      );
    } else {

      let responseSingle = this.holdingsResponseValue['response'];
      this.assetMoverDetails = this.holdingsResponseValue['response'];
       responseSingle.positions.forEach(item2 => {
        // console.log("assetTypeCode" + item2.security.assetTypeCode);
       this.getPartialRes(item2);
      })
    
    }
  }
  ngOnDestroy() {
    if (this.holdingSymbolDetails) {
      this.holdingSymbolDetails.unsubscribe();
    }
    if (this.modNewsDetails) {
      this.modNewsDetails.unsubscribe();
    }
  }

}
